<template>
  <a-modal v-model="open" :title="title" @cancel="cancel" :maskClosable="false" :closable="!confirming"
    :width="modalWidth_">
    <a-form ref="formRef" name="form" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
      autocomplete="off" size="large" style="width:100%;">
      <a-form-item name="address" style="width:100%;">
        <a-input-search v-model="form.address" placeholder="地址关键词" enter-button="搜索" @search="getdata()" />
      </a-form-item>
    </a-form>
    <!-- <tlbs-map ref="mapRef" api-key="HJYBZ-XQM6U-GIMVP-GG4XQ-J2TBQ-4LFBV" :center="center" :zoom="zoom"
      :control="control" @click="onClickMap">
      <tlbs-multi-marker ref="markerRef" :geometries="geometries" :styles="styles" :options="options"
        @click="onClickMarker" />
      <tlbs-info-window ref="infoRef" :visible="info_visible" :position="center" :content="info_content"
        :options="info_options" @closeclick="onCloseInfoWindow" />
    </tlbs-map> -->
    <div style="padding-top:10px;">
      <span v-if="marker">
        位置：{{ marker.title }}
      </span>
      <span v-if="marker">
        地址：{{ marker.address }}
      </span>
      <span v-if="marker">
        坐标：{{ marker.location.lat }},{{ marker.location.lng }}
      </span>
    </div>
    <template #footer>
      <a-space>
        <a-button @click="cancel" :disabled="confirming">
          {{ cancelText }}
        </a-button>
        <a-button type="primary" @click="confirm" :loading="confirming">
          {{ confirmText }}
        </a-button>
      </a-space>
    </template>
  </a-modal>
</template>
<script>
import { message } from "ant-design-vue";
import _ from "underscore";

export default {
  name: "chooselocation",
  props: ["modalWidth", "latitude", "longitude", "width", "height"],
  data() {
    return {
      modalWidth_: "1000px",
      latitude_: 34.745697,
      longitude_: 113.645217,
      width_: '100%',
      height_: '100%',
      center: {
        lat: 33.857612,
        lng: 113.894131,
      },
      zoom: 13,
      control: {
        scale: {},
        zoom: {
          position: 'topRight'
        },
      },
      geometries: [],
      styles: {
        marker: {
          width: 20,
          height: 30,
          anchor: { x: 10, y: 30 },
        },
      },
      options: {
        minZoom: 5,
        maxZoom: 15,
      },
      info_visible: false,
      info_content: "",
      info_options: {
        offset: { x: 0, y: -32 }
      },
      form: {
        address: "",
      },
      searching: false,
      data: [],
      marker: null,
      open: false,
      title: "",
      confirmText: "确认",
      cancelText: "取消",
      confirming: false,
    };
  },
  computed: {

  },
  watch: {
    modalWidth(value) {
      this.modalWidth_ = value || '1000px';
    },
    latitude(value) {
      this.latitude_ = value || 34.745697;
    },
    longitude(value) {
      this.longitude_ = value || 113.645217;
    },
    width(value) {
      this.width_ = value || '100%';
    },
    height(value) {
      this.height_ = value || '100%';
    },
  },
  activated() {
    this.modalWidth_ = this.modalWidth || '1000px';
    this.latitude_ = this.latitude || 34.745697;
    this.longitude_ = this.longitude || 113.645217;
    this.width_ = this.width || '100%';
    this.height_ = this.height || '100%';
  },
  deactivated() {
    // this.$refs.mapRef.destroy();
  },
  methods: {
    init(payload) {
      // if (typeof payload?.open === 'boolean') this.open = payload.open;
      // if (typeof payload?.title === 'string') this.title = payload.title;
      // if (typeof payload?.confirmText === 'string') this.confirmText = payload.confirmText;
      // if (typeof payload?.cancelText === 'string') this.cancelText = payload.cancelText;
      // if (typeof payload?.confirming === 'boolean') this.confirming = payload.confirming;
      // if (_.isObject(payload?.form)) this.form = payload.form;
      this.$downloadBrowser({ href: "https://lbs.amap.com/tools/picker" });
    },
    initMap({ lat, lng, list }) {
      if (lat && lng) this.center = { lat, lng };
      if (Array.isArray(list)) {
        this.data = list;
        this.showMarker();
      }
    },
    onClickMap(e) {
      console.log("onClickMap", e);
    },
    onClickMarker(e) {
      console.log('onClickMarker', e);
      this.marker = this.data[Number(e.geometry.id)]
      this.center = e.geometry.position;
      this.info_content = this.makeInfoWindow(e.geometry.properties);
      this.info_visible = true;
    },
    onCloseInfoWindow(e) {
      console.log('onCloseInfoWindow', e)
      this.info_visible = false;
    },
    makeMarkers(markers) {
      let geometries = [];
      for (let i = 0; i < markers.length; i++) {
        let { location } = markers[i];
        geometries.push({
          id: String(i),
          styleId: 'marker',
          position: location,
          properties: markers[i],
        });
      }
      return geometries;
    },
    makeInfoWindow(item) {
      return `<h3>${item.title}</h3><p>地址：${item.address}</p>`;
    },
    showMarker() {
      if (this.data.length > 0) {
        let { location } = this.data[0];
        this.geometries = this.makeMarkers(this.data);
        this.marker = this.data[0];
        this.center = location;
        this.info_content = this.makeInfoWindow(this.marker);
        this.info_visible = true;
      }
    },
    getdata() {
      this.searching = true;
      this.$api.doAPI("/map/search", { dataForm: this.form }).then((res) => {
        this.searching = false;
        if (res.code === 0) {
          this.data = res.data;
          this.showMarker();
        } else {
          message.error(res.msg);
        }
      }).catch((err) => {
        this.searching = false;
        console.error(err);
      });
    },
    confirm() {
      console.log('confirm');
      this.$emit('on-location-confirmed', this.marker);
      this.open = false;
    },
    cancel() {
      console.log('cancel');
      // this.$refs.mapRef.destroy();
      this.open = false;
    },
  }
}
</script>
<style lang="less" scoped></style>